import React from "react";

function WardVacuumUnit() {
  return (
    <>
      <style>{`
        .wvu-container {
          padding: 2rem;
          background-color: #f8f9fa;
          font-family: 'Segoe UI', sans-serif;
        }

        .wvu-section {
          max-width: 900px;
          margin: 0 auto;
          background-color: #ffffff;
          padding: 2rem;
          border-radius: 10px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
        }

        .wvu-section h1 {
          text-align: center;
          font-size: 2.5rem;
          color: #2c3e50;
          margin-bottom: 2rem;
        }

        .wvu-section img {
          display: block;
          margin: 0 auto 2rem;
          max-width: 100%;
          height: auto;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
         
        }

        .wvu-section p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #555;
          text-align: justify;
          white-space: pre-line; /* Preserves bullet points or line breaks if used */
        }

        @media (max-width: 768px) {
          .wvu-section h1 {
            font-size: 2rem;
          }

          .wvu-section p {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .wvu-container {
            padding: 1rem;
          }

          .wvu-section {
            padding: 1.5rem;
          }
        }
      `}</style>

      <main className="wvu-container">
        <section className="wvu-section">
          <h1>Ward Vacuum Unit</h1>
          <img src="wvu.png" alt="Ward Vacuum Unit" />
          <p>
            The ward vacuum unit we manufacture is designed for minimum servicing and high efficiency.
            These products have the capacity of 600/1000/2000 mI.

            • Regulator body, which houses an on/off switch, regulation knob, vacuum gauge graduated in mbar.{"\n"}
            • The on/off switch allows the operator to start or stop suction by turning the switch.{"\n"}
            • With regulation knob operation, the operator can set the necessary vacuum amount.{"\n"}
            • The jar is made of polycarbonate — transparent, unbreakable, and autoclavable at 121°.{"\n"}
            • A well-proven fluid control trap (safety) fitted on the unit automatically and efficiently shuts off vacuum fully, preventing the transfer of liquid to the vacuum regulator, pipeline, and pump.
          </p>
        </section>
      </main>
    </>
  );
}

export default WardVacuumUnit;
